<div class="bp-modal mod-lg wrapper">
	<bp-modal-header>
		<button class="close-button" right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">
			<strong>{{ "close" | translate }}</strong>
		</button>
	</bp-modal-header>

	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="pt-30">
				<div class="logo-combined center-block">
					<img class="asset-logo" [src]="data.asset.logo" />
					<img class="network-logo" [src]="data.network.logo" />
				</div>
				<p class="font-size-24 mt-10 stronger-text">{{ data.owner_legal_name }}</p>
				<p class="wallet-address">{{
					"wallet_asset_on_address" | translate: [data.asset.name, data.network.name]
				}}</p>
			</div>
		</div>
	</div>

	<div class="wallet-details-wrapper">
		<div class="wallet-details--item">
			<p class="stronger-text font-size-13">{{ "wallet_addresses" | translate }}</p>
			<div class="wallet-address-details flex justify-between mb-11">
				<p class="font-size-17">{{ data.wallet_address }}</p>
				<a class="bpi__icon-send stronger-text font-size-20" (click)="send()" [tabIndex]="1"></a>
			</div>
		</div>
		<div class="wallet-details--item" [class.no-border]="!data.wallet_destination_tag">
			<p class="stronger-text font-size-13">{{ "wallet_host" | translate }}</p>
			<p class="mb-11">{{ data.wallet_host_name }}</p>
		</div>

		@if (data.legal_entity_identifier) {
			<div class="wallet-details--item" [class.no-border]="!data.wallet_destination_tag">
				<p class="stronger-text font-size-13">{{ "legal_entity_identifier" | translate }}</p>
				<p class="mb-11">{{ data.legal_entity_identifier }}</p>
			</div>
		}

		@if (data.wallet_destination_tag) {
			<div class="wallet-details--item no-border">
				<p class="stronger-text font-size-13">{{ destinationTagLabel }}</p>
				<p class="mb-11">{{ data.wallet_destination_tag }}</p>
			</div>
		}

		<div class="delete-button pt-30 text-center stronger-text">
			<a (click)="deleteWallet()" [tabIndex]="1">
				{{ "delete_wallet" | translate }}
			</a>
		</div>
	</div>
</div>
